"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TotalLossDecisionStateFlags = void 0;
var TotalLossDecisionStateFlags;
(function (TotalLossDecisionStateFlags) {
    TotalLossDecisionStateFlags[TotalLossDecisionStateFlags["None"] = 0] = "None";
    TotalLossDecisionStateFlags[TotalLossDecisionStateFlags["AI"] = 1] = "AI";
    TotalLossDecisionStateFlags[TotalLossDecisionStateFlags["InternalDamage"] = 2] = "InternalDamage";
})(TotalLossDecisionStateFlags = exports.TotalLossDecisionStateFlags || (exports.TotalLossDecisionStateFlags = {}));
